
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30","viewBox":"0 0 30 30"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 140073"}},[_c('g',{attrs:{"data-name":"Smiling Face with Heart-Eyes"}},[_c('g',{attrs:{"transform":"translate(.226 .712)"}},[_c('circle',{attrs:{"data-name":"Ellipse 6555","cx":"14.439","cy":"14.439","fill":"#fdca47","r":"14.439"}}),_c('path',{attrs:{"data-name":"Path 154669","d":"M2.324 9.573a7.854 7.854 0 011.04-3.018 9.942 9.942 0 014.809-4.186 7.8 7.8 0 013.135-.608c-.928.53-1.8 1.022-2.631 1.574a21.9 21.9 0 00-4.429 3.851c-.662.746-1.271 1.545-1.924 2.387z","fill":"#ffe8bb"}})]),_c('path',{attrs:{"d":"M9.018 17.868a1.313 1.313 0 00-1.526 1.656 7.47 7.47 0 0014.341 0 1.313 1.313 0 00-1.526-1.656 27.755 27.755 0 01-11.289 0z","fill":"#664100"}}),_c('g',{attrs:{"data-name":"Group 139880","fill":"#df2540"}},[_c('path',{attrs:{"data-name":"Path 154671","d":"M28.588 6.922a3.592 3.592 0 00-5.916-2.954 3.731 3.731 0 00-2.365-2.608 3.642 3.642 0 00-4.174 1.431 3.776 3.776 0 00-.55 1.433c-.581 3.206.895 6.281 3.344 9.295a.987.987 0 001.007.334c3.765-.952 6.786-2.536 8.237-5.453a3.775 3.775 0 00.417-1.478z"}}),_c('path',{attrs:{"data-name":"Path 154672","d":"M.742 6.922A3.643 3.643 0 013.233 3.28a4.122 4.122 0 013.591.944 3.911 3.911 0 012.2-2.864 3.643 3.643 0 014.174 1.431 3.776 3.776 0 01.549 1.433c.581 3.206-.895 6.281-3.344 9.295a.987.987 0 01-1.007.334C5.631 12.901 2.61 11.317 1.159 8.4a3.777 3.777 0 01-.417-1.478z"}})])])])])
          )
        }
      }
    